// extracted by mini-css-extract-plugin
export var deleteModal = "_gz-0";